// extracted by mini-css-extract-plugin
var _1 = "TopLevelTopicSettings-module__animateUploadProgressBarWidth--ESFXO";
var _2 = "TopLevelTopicSettings-module__animatedBackground--vkehL";
var _3 = "TopLevelTopicSettings-module__description--yQU0h";
var _4 = "TopLevelTopicSettings-module__formFields--QmCv1";
var _5 = "TopLevelTopicSettings-module__formFooter--POLYE";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "description", _4 as "formFields", _5 as "formFooter" }
